import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {AnagraficaInTdocComponent} from './anagrafica-in-tdoc';
import {WorkerAnagraficaInTdocModalModule} from './worker-anagrafica-in-tdoc-modal/worker-anagrafica-in-tdoc-modal.module';
import {WorkerAnagraficaInTdocModule} from './worker-anagrafica-in-tdoc-result/worker-anagrafica-in-tdoc.module';

let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.anagrafica-in-tdoc', {
            url: '/anagrafica-in-tdoc',
            ncyBreadcrumb: {
                label: 'Anagrafica in tDoc',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'Anagrafica in tDoc'
            },
            'views': {
                'homeContent': {
                    template: '<anagrafica-in-tdoc flex="100"></anagrafica-in-tdoc>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const AnagraficaInTdocModule: string = ng
    .module('anagrafica-in-tdoc', [
        'ui.bootstrap',
        uiRouter,
      WorkerAnagraficaInTdocModalModule,
      WorkerAnagraficaInTdocModule
    ])
    .component('anagraficaInTdoc', AnagraficaInTdocComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/anagrafica-in-tdoc/anagrafica-in-tdoc.module.ts